import React from "react";
import styles from "./styles.css";
import infoImage from "./images/information.svg";
import PropTypes from "prop-types";
import { getBoldText } from "../../../utils/helpers/get-span-for-bold-text";

const ServicingCarCoveredCard = ({ info = "" }) => {
    return (
        <div styleName={"styles.outer"}>
            <img src={infoImage} />
            <p styleName={"styles.information"}>{getBoldText(info)}</p>
        </div>
    );
};

ServicingCarCoveredCard.propTypes = {
    info: PropTypes.string
};

export default ServicingCarCoveredCard;
